import { $t } from "@/i18n";
import { APP_STORE_APP_TYPES, APP_STORE_BUNDLE_TYPES } from "@/helpers/constants";
import { get_country_from_code } from "@/helpers/formatting"

export const appStoreManifest = {
    // BUNDLES
    [APP_STORE_BUNDLE_TYPES.TRIAL]: {
        getTitle: () => $t("Free trial"),
        description: $t(""),
    },
    [APP_STORE_BUNDLE_TYPES.SOLO]: {
        getTitle: () => $t("Solo"),
        description: '',
    },
    [APP_STORE_BUNDLE_TYPES.TEAM]: {
        getTitle: () => $t("Team"),
        description: '',
    },
    [APP_STORE_BUNDLE_TYPES.ENTERPRISE]: {
        getTitle: () => $t("Enterprise"),
        description: '',
    },

    // FEATURES
    [APP_STORE_APP_TYPES.MINI_UKU]: {
        getTitle: () => $t("Mini Uku"),
        getDescription: () => $t("Chrome browser plugin for Uku to manage your task, clients and track time."),
        logo_url: "icon_Mini_Uku.svg",
    },
    [APP_STORE_APP_TYPES.TASKS]: {
        getTitle: () => $t("Tasks"),
        getDescription: () => $t("Setup task/job plans to automate your workflow, add topics, custom fields and modify your preferences."),
        logo_url: "icon_tasks.svg",
        component : () => import("@/views/AppStore/Tasks/TasksDialogContent.vue")
    },
    [APP_STORE_APP_TYPES.CLIENTS]: {
        getTitle: () => $t("Clients"),
        getDescription: () => $t("Setup client groups, custom fields and modify your preferences."),
        logo_url: "icon_clients.svg",
        component : () => import("@/views/AppStore/Clients/ClientsDialogContent")
    },
    [APP_STORE_APP_TYPES.COMPANY]: {
        getTitle: () => $t("Company"),
        getDescription: () => $t("test"),
        logo_url: "app-company.svg",
        picture_width: "56",
        component : () => import("@/views/AppStore/Company/CompanyDialogContent")
    },
    [APP_STORE_APP_TYPES.AML]: {
        getTitle: () => $t("Anti Money Laundering"),
        getDescription: () => $t("Setup your customer AML and get instant reminders when auditing is due."),
        logo_url: "app-aml.svg",
        component : () => import("@/views/AppStore/AML/AMLDialogContent")
    },
    [APP_STORE_APP_TYPES.FLEXTIME]: {
        getTitle: () => $t("Flextime"),
        getDescription: () => $t("flextime_description"),
        logo_url: "app-flextime.svg",
        component : () => import("@/views/AppStore/Flextime/FlextimeDialogContent")
    },
    [APP_STORE_APP_TYPES.SMART_ACCOUNTS]: {
        getTitle: () => $t("Smart Accounts"),
        getDescription: () => $t("Automatically imports work statistics from your accounting software."),
        logo_url: "smart_accounts.png",
        logoFullWidth: true,
        component : () => import("@/views/AppStore/SmartAccounts/SmartAccountsDialogContent")
    },
    [APP_STORE_APP_TYPES.MERIT_AKTIVA]: {
        getTitle: () => $t("Merit Aktiva"),
        title_region: {
            pl: $t('360 Księgowość')
        },
        getDescription: () => $t("Automatically imports work statistics from your accounting software."),
        logo_url: "merit_activa.png",
        logoFullWidth: true,
        logo_url_region: {
            pl: 'merit_aktiva_poland.png'
        },
        component : () => import("@/views/AppStore/MeritAktiva/MeritActivaDialogContent")
    },
    [APP_STORE_APP_TYPES.BILLING]: {
        getTitle: () => $t("Billing"),
        getDescription: () => $t("Speed up your client billing process with pricelists and smart contracts."),
        component : () => import("@/views/AppStore/Billing/BillingDialogContent"),
        logo_url: 'app-billing.svg'
    },
    [APP_STORE_APP_TYPES.MONITORING]: {
        getTitle: () => $t("Monitoring"),
        getDescription: () => $t("Visual report will tell you exactly how profitable or unprofitable your client is."),
        component : () => import("@/views/AppStore/Monitoring/MonitoringDialogContent"),
        logo_url: 'app-monitoring.svg'
    },
    [APP_STORE_APP_TYPES.EMAILING]: {
        getTitle: () => $t("Emails"),
        getDescription: () => $t("Emailing description"),
        logo_url: "app-emailing.svg",
        component : () => import("@/views/AppStore/Emailing/EmailingDialogContent")
    },
    [APP_STORE_APP_TYPES.ECONOMIC]: {
        getTitle: () => $t("e-conomic"),
        getDescription: () => $t("Sync client data from Uku to e-conomic and vice versa. View sales ledger information for each client."),
        logo_url: "app-economic.png",
        picture_width: "57",
        component : () => import("@/views/AppStore/Economic/EconomicDialogContent")
    },
    [APP_STORE_APP_TYPES.XERO]: {
        getTitle: () => $t("Xero"),
        getDescription: () => $t("xero_description"),
        logo_url: "app-xero.svg",
        picture_width: "57",
        component : () => import("@/views/AppStore/Xero/XeroDialogContent")
    },
    [APP_STORE_APP_TYPES.QUICKBOOKS]: {
        getTitle: () => $t("QuickBooks"),
        getDescription: () => $t("quickbooks_description"),
        logo_url: "app-quickbooks.png",
        picture_width: "86",
        component : () => import("@/views/AppStore/QuickBooks/QuickBooksDialogContent")
    },
    [APP_STORE_APP_TYPES.TRIPLETEX]: {
        getTitle: () => $t("Tripletex"),
        getDescription: () => $t("tripletex_description"),
        logo_url: "app-tripletex.svg",
        picture_width: "86",
        component : () => import("@/views/AppStore/Tripletex/TripletexDialogContent")
    },
//    [APP_STORE_APP_TYPES.SCORO]: {
//        title: $t("Scoro"),
//        description: $t("Export sales invoices."),
//        logo_url: "scoro_logo.svg",
//    },
    [APP_STORE_APP_TYPES.FORTNOX]: {
        getTitle: () => $t("Fortnox"),
        getDescription: () => $t("fortnox_description"),
        logo_url: "app-fortnox.svg",
        picture_width: "86",
        component : () => import("@/views/AppStore/Fortnox/FortnoxDialogContent")
    },
    [APP_STORE_APP_TYPES.MAGIC_BUTTON]: {
        getTitle: () => $t("Magic button"),
        getDescription: () => $t("With one click - a quick and easy way to create important tasks. For example, a phone call from a client."),
        logo_url: "app-magic-button.svg",
        component : () => import("@/views/AppStore/MagicButton/MagicButtonDialogContent")
    },
    [APP_STORE_APP_TYPES.SUPPLIER]: {
        getTitle: () => $t("Suppliers"),
        getDescription: () => $t("With suppliers, you make your projects and partners management more efficient."),
        logo_url: "app-supplier.svg",
        component : () => import("@/views/AppStore/Supplier/SupplierDialogContent")
    },
    [APP_STORE_APP_TYPES.PROJECT]: {
        getTitle: () => $t("Projects"),
        getDescription: () => $t("Powerful and flexible project management serves diverse use cases and workflows."),
        logo_url: "app-project.svg",
        component : () => import("@/views/AppStore/Project/ProjectDialogContent")
    },
    [APP_STORE_APP_TYPES.CLIENT_PORTAL]: {
        getTitle: () => $t("Client portal"),
        getDescription: () => $t("client_portal_app_description"),
        logo_url: "app-client-portal.svg",
        component : () => import("@/views/AppStore/ClientPortal/ClientPortalDialogContent")
    },
    [APP_STORE_APP_TYPES.CHAT]: {
        getTitle: () => $t("Chat"),
        getDescription: () => $t("chat_app_description"),
        logo_url: "app-chat.svg",
        component : () => import("@/views/AppStore/Chat/ChatDialogContent")
    },
    [APP_STORE_APP_TYPES.COMPANIES_HOUSE]: {
        getTitle: () => $t("Companies House"),
        getDescription: () => $t("companies_house_app_description"),
        logo_url: "app-companies-house.svg",
        component : () => import("@/views/AppStore/CompaniesHouse/CompaniesHouseDialogContent")
    },
    [APP_STORE_APP_TYPES.DOCUMENTS]: {
        getTitle: () => $t("Documents"),
        getDescription: () => $t("documents_app_description"),
        logo_url: "icon_documents.svg",
        component : () => import("@/views/AppStore/Documents/DocumentsDialogContent")
    },
    [APP_STORE_APP_TYPES.FREEAGENT]: {
        getTitle: () => $t("FreeAgent"),
        getDescription: () => $t("freeagent_description"),
        logo_url: "app-freeagent.svg",
        picture_width: "86",
        component : () => import("@/views/AppStore/FreeAgent/FreeagentDialogContent")
    },
    [APP_STORE_APP_TYPES.TRIGON]: {
        getTitle: () => $t("Trigon"),
        getDescription: () => $t("trigon_description"),
        logo_url: "app-trigon.svg",
        component : () => import("@/views/AppStore/Trigon/TrigonDialogContent")
    }
};

export const getManifestData = function(name, key, company) {
    // Since we cannot call $t directly without it being in a method, cause it will translate by default locale instead of user locale
    // Currently left a couple ugly if checks probably better to create separate methods for these at some point, dont want to do anything big before live

    if (name === APP_STORE_APP_TYPES.COMPANY && key === 'logo_url') {
        return company ? company.avatar : null
    }

    if (name === APP_STORE_APP_TYPES.COMPANY && key === 'title') {
        return company ? company.name : null
    }

    if (name === APP_STORE_APP_TYPES.COMPANY && key === 'description') {
        if (!company) {
            return null
        }

        return [
            company.address_street,
            company.address_city,
            get_country_from_code(company.address_country_code)
        ].filter(x => x).join(', ')
    }

    if (appStoreManifest[name] === undefined) return null
    if (key === 'description' && appStoreManifest[name].getDescription) {
        return appStoreManifest[name].getDescription();
    }

    if (key === 'title' && appStoreManifest[name].getTitle) {
        return appStoreManifest[name].getTitle();
    }

    if (appStoreManifest[name][key] === undefined) return null;
    return appStoreManifest[name][key];
};

export default appStoreManifest;